// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8c28ccec","125":"dca5a6fa","498":"c7b9ab65","513":"6ba58c88","598":"c2b8918f","703":"e32765a7","810":"96a587a5"}[chunkId] + ".chunk.js";
};